import { createAtlassianGatewayClient, createTeamCentralClient, createWorklensClient, createApolloClient as newApolloClient } from '@atlassian/ptc-graphql-client';
import { DEV, getConfig } from '@atlassian/teams-common/context-config';
import { withDefaultExponentialBackoff } from '../utils/http';
const customFetch = withDefaultExponentialBackoff(fetch);

/*************************************************/
// a common Apollo Client
let cachedApolloClient;
export const getApolloClient = customConfig => {
  if (cachedApolloClient) {
    return cachedApolloClient;
  }
  const apolloClient = createApolloClient(customConfig);
  // don't cache apolloClient when cloudId is empty string
  if (customConfig !== null && customConfig !== void 0 && customConfig.getCloudId && customConfig !== null && customConfig !== void 0 && customConfig.getCloudId()) {
    cachedApolloClient = apolloClient;
  }
  return apolloClient;
};
export const createApolloClient = customConfig => newApolloClient({
  connectToDevTools: !!DEV,
  url: {
    stargateRoot: getConfig().stargateRoot,
    collaborationGraph: getConfig().collaborationGraph
  },
  customFetch,
  ...customConfig
});

/*************************************************/
// Worklens client
let cachedWorklensClient;
export const getWorklensClient = () => {
  if (cachedWorklensClient) {
    return cachedWorklensClient;
  }
  cachedWorklensClient = createWorklensClient({
    url: {
      stargateRoot: getConfig().stargateRoot
    },
    customFetch
  });
  return cachedWorklensClient;
};

/*************************************************/
// GraphQL Gateway client
let cachedGatewayClient;
export const getGatewayClient = () => {
  if (cachedGatewayClient) {
    return cachedGatewayClient;
  }
  cachedGatewayClient = createAtlassianGatewayClient({
    url: {
      stargateRoot: getConfig().stargateRoot
    },
    customFetch
  });
  return cachedGatewayClient;
};

/*************************************************/
// GraphQL Team Central client
let cachedTeamCentralClient;
export const getTeamCentralClient = () => {
  if (cachedTeamCentralClient) {
    return cachedTeamCentralClient;
  }
  cachedTeamCentralClient = createTeamCentralClient({
    url: {
      stargateRoot: getConfig().stargateRoot
    },
    customFetch
  });
  return cachedTeamCentralClient;
};